import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/routers/lans`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(lan) {
    return apiClient.post(`${lan.id}`, lan)
  },

  eliminar(idLan) {
    return apiClient.delete(`${idLan}`)
  },

  guardar(lan) {
    return apiClient.post('', lan)
  },

  lanJSON(idLan) {
    return apiClient.get(`${idLan}.json`)
  },

  lansJSON(idRouter, params) {
    params = params || {}
    return apiClient.get(`${API}/routers/${idRouter}/lans.json`, {
      params: params
    })
  }
}
